import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';
import cookie from 'react-cookie';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class Guide extends Component {
  constructor(props) {
    super(props);

    this.storeVote = this.storeVote.bind(this);
    this.upvote = this.upvote.bind(this);
    this.downvote = this.downvote.bind(this);
  }

  componentDidMount() {
    this.props.fetchGuideIfNeeded();
    trackMixpanel("Viewed help content", {
      "contentType": "guide",
      "pageType": "guide page",
      "categorySlug": null,
      "slug": this.props.params.guideSlug,
    });
  }

  storeVote(up) {
    /* save vote in a cookie so it can be restored in future visits */
    cookie.save(`guide_${this.props.guide.id}_upvoted`, up, {path: '/'})
  }

  upvote() {
    this.storeVote(true)
    this.props.upvote()
  }

  downvote() {
    this.storeVote(false)
    this.props.downvote()
  }

  render() {
    const { isLoading, guide } = this.props;

    if (!guide || isLoading) {
      return <LoadingIndicator />;
    }
    const content = { __html: guide.body };

    const upVoted = cookie.load(`guide_${guide.id}_upvoted`);

    return (
      <div className="help-content help-article">
        <Meta
          title={`${guide.title} | Help | crowdspring`}
          meta={[
            { name: 'description', content: guide.html_meta_description },
            { name: 'keywords', content: guide.html_meta_keywords },
            { property: 'og:title', content: `${guide.title} | crowdspring` },
            { property: 'og:url', content: getCanonicalURL(`/help/guides/${guide.slug}/`) },
            { property: 'og:description', content: guide.html_meta_description },
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/guides/${guide.slug}/`) }]}
        />
        <div className="row column">
          <ul className="help-breadcrumb">
            <li><Link to="/help/">Help Center</Link></li>
            <li><Link to="/help/guides/">Guides</Link></li>
            <li className="active">{guide.title}</li>
          </ul>
        </div>
        <div className="row">
          <article className="small-16 medium-12 columns">
            <h1 className="article-title">{guide.title}</h1>
            <div
              className="article-content"
              dangerouslySetInnerHTML={content}
            />
            <div className="article-rating">
              <span>Was this guide helpful?</span> {' '}
              <button className={"btn btn-icon-only upvote"  + (upVoted == "true"? " active":"")}
                      disabled={upVoted != undefined}
                      onClick={this.upvote}
              >
                { upVoted === "true" ?
                  <i className="fa fa-heart"/>:
                  <i className="fa fa-heart-o"/>
                }
                <span className="votes">{guide.votes.helpful}</span>
              </button>
              <button className={"btn btn-icon-only downvote" + (upVoted == "false" ? " active":"")}
                      disabled={upVoted != undefined}
                      onClick={this.downvote}
              >
                { upVoted === "false" ?
                  <i className="fa fa-thumbs-down "/>:
                  <i className="fa fa-thumbs-o-down"/>
                }
                <span className="votes">{guide.votes.total - guide.votes.helpful}</span>
              </button>
            </div>
          </article>
        </div>
      </div>
    );
  }
}

Guide.propTypes = {
  fetchGuideIfNeeded: PropTypes.func.isRequired,
  upvote: PropTypes.func.isRequired,
  downvote: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  guide: PropTypes.any,
};



// WEBPACK FOOTER //
// ./help/components/guide.jsx